import api from "services/api";
import type {
  ExtratoFinanceiroApiResponse,
  ExtratoFinanceiroFiltros,
} from "../types/extrato-financeiro.types";

export function montarParamsExtratoFinanceiro(
  filtros: ExtratoFinanceiroFiltros,
): Record<string, string | number> {
  const p: Record<string, string | number> = {};
  p.page = filtros.page ?? 1;
  p.limit = filtros.limit ?? 20;

  if (filtros.dataInicio?.trim()) p.dataInicio = filtros.dataInicio.trim();
  if (filtros.dataFim?.trim()) p.dataFim = filtros.dataFim.trim();
  if (filtros.contaFinanceiraId?.trim())
    p.contaFinanceiraId = filtros.contaFinanceiraId.trim();
  if (filtros.tipo?.trim()) p.tipo = filtros.tipo.trim();
  if (filtros.categoria?.trim()) p.categoria = filtros.categoria.trim();
  if (filtros.origem?.trim()) p.origem = filtros.origem.trim();
  if (filtros.centroCustoId?.trim())
    p.centroCustoId = filtros.centroCustoId.trim();
  if (filtros.pedidoId?.trim()) p.pedidoId = filtros.pedidoId.trim();
  if (filtros.tituloReceberId?.trim())
    p.tituloReceberId = filtros.tituloReceberId.trim();
  if (filtros.tituloPagarId?.trim())
    p.tituloPagarId = filtros.tituloPagarId.trim();
  if (filtros.pagamentoId?.trim())
    p.pagamentoId = filtros.pagamentoId.trim();
  if (filtros.busca?.trim()) p.busca = filtros.busca.trim();
  if (filtros.ocultarAjusteSistema) p.ocultarAjusteSistema = "true";

  return p;
}

export async function listarExtratoFinanceiro(
  filtros: ExtratoFinanceiroFiltros,
): Promise<{ data: ExtratoFinanceiroApiResponse | null; status: number }> {
  const res = await api.get<ExtratoFinanceiroApiResponse>(
    "/loja/financeiro/movimentacoes-financeiras",
    { params: montarParamsExtratoFinanceiro(filtros) },
  );
  return { data: res.data ?? null, status: res.status };
}

export type ResincronizarExtratoFinanceiroBody = {
  pedidoId?: string;
  pagamentoId?: string;
  pagamentoInscricaoId?: number;
};

export type ResincronizarExtratoFinanceiroResponse = {
  movimentacoesCriadas: number;
  estornosRegistrados: number;
  itensProcessados: number;
  detalhes: Array<{
    tipo: "loja" | "inscricao";
    id: string;
    movimentacoesCriadas: number;
    estornoRegistrado: boolean;
  }>;
};

export async function resincronizarExtratoFinanceiro(
  body: ResincronizarExtratoFinanceiroBody,
): Promise<{
  data: ResincronizarExtratoFinanceiroResponse | null;
  status: number;
  error?: string;
}> {
  try {
    const res = await api.post<ResincronizarExtratoFinanceiroResponse>(
      "/loja/financeiro/extrato/resincronizar",
      body,
    );
    return { data: res.data ?? null, status: res.status };
  } catch (e: unknown) {
    const err = e as { response?: { status?: number; data?: { error?: string } } };
    return {
      data: null,
      status: err.response?.status ?? 500,
      error: err.response?.data?.error ?? "Falha ao resincronizar extrato.",
    };
  }
}
